const CHARGER_SET = 'charger-set';

const isAccessory = (handle: string | string[]) => {
  return handle === CHARGER_SET;
};

export default isAccessory;
